import './HomePage.css'
import WhyUsCards from './WhyChooseus'
import React, { useState, useEffect } from 'react';
import axios from 'axios';
function HomePageIntro(){
  const [aboutUsContent, setAboutUsContent] = useState('');
      const [loading, setLoading] = useState(false);
          const [message, setMessage] = useState('');
          
  useEffect(() => {
    fetchAboutUsContent();
}, []);

const fetchAboutUsContent = async () => {
    setLoading(true);
    try {
        const response = await axios.get('https://zoomautos.co.uk/api/about-us', {
            
          params: {
            _t: new Date().getTime(), // Add timestamp to bypass cache
          },
        
        });
        setAboutUsContent(response.data.content || '');
    } catch (error) {
        setMessage('Failed to fetch content.');
    } finally {
        setLoading(false);
    }
};
return(
<div className="content">
          <h1>About Us</h1>
          <p>{aboutUsContent}</p>
          <h1 style={{color:"white"}}>Why Us</h1>
          <WhyUsCards/>
        </div>
)
}
export default HomePageIntro